import { useState } from "react";
import { CitationDetailPopover } from "./CitationDetailPopover";

export const SourceBadge = ({ index, sessionId, messageId }) => {
  const [open, setOpen] = useState(false);
  return (
    <CitationDetailPopover
      open={open}
      setOpen={setOpen}
      sessionId={sessionId}
      messageId={messageId}
      trigger={
        <button
          type="button"
          className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-primary/10 px-1.5 text-[10px] font-semibold text-primary hover:bg-primary/15"
          aria-label={`Open source ${index}`}
        >
          [{index}]
        </button>
      }
    />
  );
};
